import { createSelector } from 'reselect';
import { mapWithDefault, toJs } from '../../../utils/dataMapper';

const selectStep11 = (state) => state.get('step11');

const makeSelectStep11 = () => createSelector(
  selectStep11,
  (step11State) => ({
    isThereAnyThingElseYouWouldLikeToClaimFor: mapWithDefault(step11State, () => step11State.getIn(['form', 'isThereAnyThingElseYouWouldLikeToClaimFor']), ''),
    areYouClaimingForPersonalLiability: mapWithDefault(step11State, () => step11State.getIn(['form', 'areYouClaimingForPersonalLiability']), ''),
    areYouClaimingForGolfPackOptionalCover: mapWithDefault(step11State, () => step11State.getIn(['form', 'areYouClaimingForGolfPackOptionalCover']), ''),
    areYouClaimingForBicyclePackOptionalCover: mapWithDefault(step11State, () => step11State.getIn(['form', 'areYouClaimingForBicyclePackOptionalCover']), ''),
    personalLiabilitiesClaimDetail: mapWithDefault(step11State, () => toJs(step11State.getIn(['form', 'personalLiabilitiesClaimDetail'])), ''),
    golfPackOptionalClaimDetail: mapWithDefault(step11State, () => toJs(step11State.getIn(['form', 'golfPackOptionalClaimDetail'])), ''),
    bicyclePackOptionalClaimDetail: mapWithDefault(step11State, () => toJs(step11State.getIn(['form', 'bicyclePackOptionalClaimDetail'])), ''),
    personalLiabilitiesExpensesClaimed: mapWithDefault(step11State, () => toJs(step11State.getIn(['form', 'personalLiabilitiesExpensesClaimed'])), ''),
    golfPackOptionalExpensesClaimed: mapWithDefault(step11State, () => toJs(step11State.getIn(['form', 'golfPackOptionalExpensesClaimed'])), ''),
    bicyclePackOptionalExpensesClaimed: mapWithDefault(step11State, () => toJs(step11State.getIn(['form', 'bicyclePackOptionalExpensesClaimed'])), ''),
    anythingElse: mapWithDefault(step11State, () => toJs(step11State.getIn(['form', 'anythingElse'])), ''),
    anythingElseExpensesClaimed: mapWithDefault(step11State, () => toJs(step11State.getIn(['form', 'anythingElseExpensesClaimed'])), ''),

  })
);

const makeSelectStep11Errors = () =>
  createSelector(selectStep11, (state) => state.get('errors'));

export {
  makeSelectStep11,
  makeSelectStep11Errors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step11/selectors.js